import React, { FC, ReactElement } from 'react'

import { translate } from '../../../helpers/translations/translator'
import { InfoListItem } from '../../components'
import { getPersonFullName } from '../../entities/Person/PersonHelpers'
import { BasicUser } from '../../entities/User/User'

interface EmployeesListProps {
    employees: BasicUser[];
    className?: string;
}

const EmployeesList: FC<EmployeesListProps> = ({ employees, className = '' }): ReactElement => (
    <ul className={className}>
        <InfoListItem
            label={translate('common.coworkers')}
        >
            {employees.map(employee => (
                <div key={employee.id}>
                    {getPersonFullName(employee.person)}
                </div>
            ))}
        </InfoListItem>
    </ul>
)

export default EmployeesList
